// Experiment lifecycle:
//   1. Add experiment here and deploy:
//        my_experiment: ['variant_a', 'variant_b']
//      The first variant is the default for users without a cookie (e.g. cookies disabled).
//   2. Set exp_active:my_experiment to "true" in the Cloudflare KV experiments namespace to start assigning users.
//   3. To end the experiment: set exp_active:my_experiment to "false" in the Cloudflare KV experiments namespace, or delete the key entirely.
//      No new users will be assigned. Existing cookie holders keep their variant — use a date range in your analytics
//      tool to filter data up to the end date.
//   4. Once a winner is picked: hardcode the winning variant's behaviour, remove the experiment
//      from EXPERIMENTS, and deploy. Existing cookie entries for that experiment are ignored.
export const EXPERIMENTS = {
    search_bar: ['variant_a', 'variant_b']
};
//# sourceMappingURL=experiment.js.map